import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG_LEFT = `${A}/blueprint4joy-about-dream-journal-beach.jpg`;
const IMG_RIGHT = `${A}/blueprint4joy-about-follow-dreams-sign.jpg`;
const ALT_LEFT = "Lara on a windy beach at sunset, smiling down at a red journal with the word dream on the cover.";
const ALT_RIGHT = "Lara in a pink sweater holding a hand-painted sign that reads 'Follow YOUR dreams,' hills behind her.";

export function DreamReminders() {
  return (
    <section
      data-testid="about-dream-reminders"
      className="relative overflow-hidden bg-[#EFF5F4]"
    >
      <div className="max-w-[1420px] mx-auto px-6 md:px-10 py-16 md:py-24 reveal">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-6">
          {/* Left image — sized up ~17.5%, fixed width so text column stays untouched */}
          <div className="w-full lg:w-[406px] lg:flex-shrink-0">
            <div className="relative w-full aspect-[4/5]">
              <FadedImage
                src={IMG_LEFT}
                alt={ALT_LEFT}
                testId="dream-reminders-image-left"
                bg="#EFF5F4"
                objectPosition="50% 30%"
                filter="brightness(1.06) contrast(1.04)"
                featherRight={15}
                className="absolute inset-0"
              />
            </div>
          </div>

          {/* Center copy — unchanged */}
          <div
            data-testid="dream-reminders-copy"
            className="w-full lg:w-[461px] lg:flex-shrink-0 text-center px-2 md:px-6 lg:translate-y-3"
          >
            <p className="font-display text-2xl md:text-[32px] text-[#1C1917] leading-snug mb-6">
              Dreams don&rsquo;t usually disappear.
            </p>
            <div className="space-y-3 text-lg md:text-xl leading-relaxed text-[#57534E]">
              <p>
                Life just gets loud enough that we stop hearing them.
              </p>
              <p>That&rsquo;s why I leave little reminders for myself.</p>
              <p>A sign. A journal. A conversation.</p>
              <p>Not because they have magic powers.</p>
              <p>Because sometimes I need reminding too.</p>
            </div>
          </div>

          {/* Right image — sized up ~17.5% to match */}
          <div className="w-full lg:w-[406px] lg:flex-shrink-0">
            <div className="relative w-full aspect-[4/5]">
              <FadedImage
                src={IMG_RIGHT}
                alt={ALT_RIGHT}
                testId="dream-reminders-image-right"
                bg="#EFF5F4"
                objectPosition="50% 30%"
                filter="saturate(0.93)"
                featherLeft={15}
                className="absolute inset-0"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
